<template>
  <div class="teacher-serve">
    <Title :title="serveTitle" :english-title="serveEnglishTitle "></Title>
    <div class="teacher-serve-content">
      <RecentUsed type="card" :serve-url="serveUrl" :request="request"></RecentUsed>
      <CollectionServe :serve-url="serveUrl" :request="request" @goToManageCenter="goToManageCenter"></CollectionServe>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import Title from '../components/Title';

  export default {
    name: 'Serve',
    data() {
      return {
        serveTitle: '我的服务',
        serveEnglishTitle: 'my service',
      };
    },
    components: {
      Title,
    },
    computed: {
      ...mapGetters([
        'serveUrl',
        'token',
        'request',
      ]),
    },
    methods: {
      goToManageCenter() {
        // this.$router.push('/personal-center/my-collections')
		let routeUrl = this.$router.resolve({
		          path: "/personal-center/my-collections"

		     });
		     window.open(routeUrl.href, '_blank');
      }
    }
  };
</script>
<style lang="scss">
  @import "@/styles/variables.scss";

  .teacher-serve {
    position: relative;
    display: flex;
    flex-direction: column;
    //justify-content: center;
    min-width: 960px;
    min-height: calc(100vh - 60px);
    background: -webkit-linear-gradient(rgba(250,250,250,0.8) 0%,rgba(250,250,250,1) 50%);
    padding-left: 0px;

    .components-title {
      padding-top: 50px;
      padding-bottom: 40px;
    }

    &-content {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .recentUsed {
      width: 50%;
    }

    .recentUsed-randomCard {
      margin: 0 auto;
      .mini_app {
        .vertical_app-icon {
          > img {
            border-radius: 50%;
          }
        }
      }
    }

    .CollectionServe {
      width:50%;

      .mini_app {
        .vertical_app-icon {
          border-radius: 36px;
          overflow: hidden;
        }
      }
    }
  }
</style>
